<template>
  <div>
    <div class="row mt-5 border-top p-2">
      <div class="col mt-3">
        <h4>Engagement Scale</h4>
      </div>
    </div>

    <div class="row w-100">
      <div class="col min-width-chart mx-auto my-auto pb-3">
        <doughnutChart
          :chart-data="engagement.uwesChart"
          :options="engagement.chartOptions"
          :textMiddle="engagement.uwes.engagementScaleAverage"
        ></doughnutChart>
      </div>

      <div class="col-10 border-left if-small-no-border">
        <div class="row border-bottom if-small-add-border">
          <div class="col pt-3 my-auto">
            <div class="text-center"><h5>Vigor</h5></div>
            <p>
              Vigor refers to high levels of energy and mental resilience while
              working and the willingness to invest effort in one’s work, and
              persistence in the face of difficulties.
            </p>
          </div>
          <div class="col max-width-chart p-2 my-auto">
            <doughnutChart
              :chart-data="engagement.uwesSubCharts.vigor"
              :options="engagement.chartOptions"
              :textMiddle="engagement.uwes.engagementSubscale.vigorPercentage"
            ></doughnutChart>
          </div>
          <div class="col pt-3 my-auto border-left">
            <div><h5>Suggestion:</h5></div>
            <ul>
              <li>Try reminding them how valuable they are for the company, without them the work won’t be done</li>
              <li>Ask them how they are doing</li>
              <li>A change of task or job might help improve their motivation</li>
              <li>Approach them with enthusiasm and happiness</li>
            </ul>
          </div>
        </div>

        <div class="row border-bottom">
          <div class="col pt-3 my-auto">
            <div class="text-center"><h5>Dedication</h5></div>
            <p>
              Dedication refers to being involved in one’s work, finding meaning
              in one’s work, being challenged, and experiencing a sense of
              enthusiasm, inspiration and pride.
            </p>
          </div>
          <div class="col max-width-chart p-2 my-auto">
            <doughnutChart
              :chart-data="engagement.uwesSubCharts.dedication"
              :options="engagement.chartOptions"
              :textMiddle="engagement.uwes.engagementSubscale.dedicationPercentage"
            ></doughnutChart>
          </div>
          <div class="col pt-3 my-auto border-left">
            <div><h5>Suggestion:</h5></div>
            <ul>
              <li>Use incentives like gift cards, free lunches or just simply thank them for their work</li>
              <li>Recognize employee’s for their work</li>
              <li>A change of task or job might help improve their motivation</li>
              <li>Be honest and genuine when communicating with employee’s</li>
            </ul>
          </div>
        </div>

        <div class="row">
          <div class="col pt-3 my-auto">
            <div class="text-center"><h5>Absorption</h5></div>
            <p>
              Absorption refers to being fully concentrated and engrossed in
              one’s work, whereby time passes quickly, and one has difficulties
              detaching oneself from work.
            </p>
          </div>
          <div class="col max-width-chart p-2 my-auto">
            <doughnutChart
              :chart-data="engagement.uwesSubCharts.absorption"
              :options="engagement.chartOptions"
              :textMiddle="engagement.uwes.engagementSubscale.absorptionPercentage"
            ></doughnutChart>
          </div>
          <div class="col pt-3 my-auto border-left">
            <div><h5>Suggestion:</h5></div>
            <ul>
              <li>Ask what employees need to do their work better</li>
              <li>Play the advocate for their requests. You have more power than them, try to make it happen</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import doughnutChart from "@/components/engagement/charts/percentageDoughnutChart.js";
import { Doughnut, mixins } from "vue-chartjs";

import { adjustColor } from "@/mixins/engagement/adjustChartColor.js";

export default {
  extends: Doughnut,
  mixins: [mixins.reactiveProp, adjustColor],
  props: ["chartData", "engagement"],
  components: {
    doughnutChart,
  },
  data() {
    return {
    };
  },

  mounted() {
    
  },
  methods: {
    addChartData(value) {
      let chartData = {
        datasets: 
          {
            data: [value, 100 - value],
            backgroundColor: [this.adjustColor(value)],
            borderWidth: 0,
          },
        
        labels: [""],
      };

      return chartData;
    },
  },
};
</script>

<style scoped lang="scss">
@import "./src/assets/scss/components/engagement/_EmployeeOverviewInDepth.scss";
</style>